<template>
  <div>
    <div class="vue-template" elevation="3">
      <Menu />
      <!-- <CopyLink /> -->
      <InfoProfile />

      <LinkProfile v-if="user.userName" />
      <div class="inner-block-logged-main vue-template-flex">
        
          <!-- Tab to move between sections of customization part of the platform, ex: logged area and profile edit -->
         <v-card 
          elevation="0"
          width="100%"
          > 
          <v-tabs
            color="purple darken-4"
            style="text-decoration: none"
            center-active
            show-arrows
            v-model="active_tab"
          >
            <!-- render the cards links on the screen  -->
            <v-tab
              v-for="tab of tabs"
              :key="tab.index"
              class="purple--text text--darken-4"
              @click="active_tab = tab.index"
              >{{ tab.name }}
            </v-tab>
          </v-tabs>
         </v-card>

          <!-- render the components Settings -->
          <Settings
            @useChanged="dataUser = $event"
            @changeForm="
              userForm = $event.userForm;
              active_tab = $event.active_tab;
            "
            :dataUser="dataUser"
            v-if="active_tab === 0"
          />

          <!-- render the components MyLinks -->
          <MyLinks v-if="active_tab === 1" class="mt-2" />
          <!-- render the component Data -->
          <Data v-if="active_tab === 2" />
          <!-- Followers tab -->
          <Followers v-if="active_tab === 3" />
          <!-- News tab -->
          <News v-if="active_tab === 4" />
        
      </div>
      <Footer class="footer-settings" v-if="userForm" />
    </div>
  </div>
</template>
<script>
import { auth, analytics } from "@/config/firebaseConfig";
import {
  getCoins,
  isMGM,
  setCoins,
  updateUserMGMDataBase,
} from "@/functions/MGM/dataBaseMGM";
import Settings from "@/components/LoggedArea/Settings/Settings";
import MyLinks from "@/components/LoggedArea/Links/MyLinks";
import Data from "@/components/LoggedArea/Data/Data";
import Followers from "@/components/LoggedArea/Followers/Followers";
import News from "@/components/LoggedArea/News/News";
import Menu from "@/components/templates/Menu";
import LinkProfile from "@/components/LoggedArea/CopyLink/LinkProfile";
import InfoProfile from "@/components/LoggedArea/InfoProfile/InfoProfile";
import Footer from "@/components/templates/Footer";
export default {
  components: {
    Settings,
    MyLinks,
    Menu,
    LinkProfile,
    InfoProfile,
    Footer,
    Data,
    Followers,
    News,
  },
  name: "LoggedMain",
  metaInfo() {
    return {
      title: this.$t("LoggedArea.LoggedMain.LoggedMain.meta.title"),
    };
  },
  data() {
    return {
      dataUser: "",
      active_tab: 1,
      tabs: [
        {
          index: 0,
          name: this.$t("LoggedArea.LoggedMain.LoggedMain.settingsTab"),
        },
      ],
      userForm: false,
    };
  },
  async created() {
    await this.getToken();
    await this.getUser();
    await this.verifyMGM();
    await this.callGetCoins();
    analytics.setUserProperties({ profileID: auth.currentUser.uid });
  },
  beforeDestroy() {
    this.$store.commit("destroyedUser");
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  watch: {
    active_tab(newTab) {
      this.userForm = newTab == 0 ? true : false;
    },
    dataUser() {
      if (this.user.userName != "" && this.tabs.length == 1) {
        this.tabs.push(
          {
            index: 1,
            name: this.$t("LoggedArea.LoggedMain.LoggedMain.linksTab"),
          },
          {
            index: 2,
            name: this.$t("LoggedArea.LoggedMain.LoggedMain.dataTab"),
          },
          {
            index: 3,
            name: this.$t("LoggedArea.LoggedMain.LoggedMain.followersTab"),
          },
          {
            index: 4,
            name: this.$t("LoggedArea.LoggedMain.LoggedMain.newTab"),
          }
        );
      }
    },
  },
  methods: {
    async verifyMGM() {
      const uid = await auth.currentUser.uid;
      const mgm = await isMGM(uid);
      if (mgm !== null) {
        if (mgm.getCoins === false) {
          await setCoins(mgm.from);
          await setCoins(uid);
          await updateUserMGMDataBase(uid, true);
        }
      }
    },
    async getToken() {
      this.$store.commit("setLoading", true);
      // Get the user's toke
      const token = await auth.currentUser.getIdToken();
      // Send the user's token to store
      this.$store.commit("getToken", token);
    },
    // Get the user's information from Database
    async getUser() {
      const userId = auth.currentUser.uid;
      const { data } = await this.$http.get(`users/${userId}.json`);
      if (data) {
        this.dataUser = data;
        this.userForm = false;
        this.active_tab = 1;
        this.$store.commit("getUser", data);
        setTimeout(() => {
          this.$store.commit("setLoading", false);
        }, 2000);
      } else {
        this.userForm = true;
        this.active_tab = 0;
        setTimeout(() => {
          this.$store.commit("setLoading", false);
        }, 2000);
      }
    },
    changeForm(index) {
      this.$store.commit("setLoading", true);
      this.userForm = index == 0 ? true : false;
      this.$store.commit("setLoading", false);
    },
    async callGetCoins() {
      const coins = await getCoins(auth.currentUser.uid);
      this.$store.commit("setCoins", coins);
    },
  },
};
</script>
<style>
.inner-block-logged-main {
  width: 350px;
  margin: 0px auto 0px;
  background: #ffffff;
}
.vue-template-flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.links-logged-area {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-logged-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.icon-email {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3f51b5;
  margin-right: 6px;
}
.footer-settings {
  margin: 0px auto 0px;
  width: 350px !important;
}
@media (max-width: 600px) {
  .inner-block-logged-main {
    margin: 0px auto 0px;
    padding: 0px 10px 10px;
    width: 300px;
  }
  .footer-settings {
    width: 300px !important;
  }
}
</style>